import { render, staticRenderFns } from "./comment_type_dropdown.vue?vue&type=template&id=051ffe92&"
import script from "./comment_type_dropdown.vue?vue&type=script&lang=js&"
export * from "./comment_type_dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports